import { NgModule } from '@angular/core';
import { AppSharedModule } from '../app-shared.module';
import { ComponentsModule } from '../components/components.module';
import { TipoProcessoDocumentoLocalRoutingModule } from './tipo-proc-doc-loc.routing';
import { TipoProcessoDocumentoLocalService } from './tipo-proc-doc-loc.service';
import { TipoProcessoDocumentoLocalEdicaoComponent } from './tipo-proc-doc-loc-edicao/tipo-proc-doc-loc-edicao.component';
import { TipoProcessoDocumentoLocalFrmComponent } from './tipo-proc-doc-loc-frm/tipo-proc-doc-loc-frm.component';
import { TipoProcessoDocumentoLocalListaComponent } from './tipo-proc-doc-loc-lista/tipo-proc-doc-loc-lista.component';


@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule
  ],
  declarations: [
    TipoProcessoDocumentoLocalListaComponent,
    TipoProcessoDocumentoLocalEdicaoComponent,
    TipoProcessoDocumentoLocalFrmComponent
  ],
  exports: [
    TipoProcessoDocumentoLocalListaComponent,
    TipoProcessoDocumentoLocalRoutingModule
  ],
  providers: [
    TipoProcessoDocumentoLocalService
  ]
})
export class TipoProcessoDocumentoLocalModule { }
